import { render, staticRenderFns } from "./edit-user.vue?vue&type=template&id=384375f2&"
import script from "./edit-user.vue?vue&type=script&lang=ts&"
export * from "./edit-user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-user.vue"
export default component.exports